/**
 * Shared Famla JWT session helpers for Office taskpane (ST SSO + email/password).
 */
import FamlaServices from '../../../services/api/FamlaServices';
import {
    clearPersistedFamlaToken,
    persistFamlaToken,
    readPersistedFamlaToken,
} from './exchangeEntraForFamlaSession';

export const OFFICE_AUTH_UNTIL_KEY = 'famla.officeAuth.until';
export const AUTH_SESSION_MS = 24 * 60 * 60 * 1000;

export type OfficeAuthMethod = 'none' | 'password' | 'microsoft';

export type OfficeDerivedUser = {
    userAzureId: string;
    userEmail: string;
    userName: string;
};

export function markAuthSession(): void {
    try {
        localStorage.setItem(OFFICE_AUTH_UNTIL_KEY, String(Date.now() + AUTH_SESSION_MS));
    } catch {
        // ignore quota / private mode
    }
}

export function clearAuthSessionMarker(): void {
    try {
        localStorage.removeItem(OFFICE_AUTH_UNTIL_KEY);
    } catch {
        // ignore
    }
    clearPersistedFamlaToken();
}

export async function loadUserFromFamlaToken(token: string): Promise<OfficeDerivedUser | null> {
    try {
        const data = await FamlaServices('api_host', '/auth/me', 'GET', '', token);
        if (data.status !== 200) return null;
        const session = data.body?.data;
        const user = session?.user;
        if (!user?.email) return null;
        return {
            userAzureId: String(user.id || user.email),
            userEmail: String(user.email),
            userName: String(user.fullname || user.email),
        };
    } catch {
        return null;
    }
}

export {
    persistFamlaToken,
    readPersistedFamlaToken,
    clearPersistedFamlaToken,
};
